// ============================================================
// PORTFOLIO DATA — edit THIS file only.
// Replace titles, thumbnails, videos, descriptions and links
// without touching any component/layout code.
// ============================================================

export const profile = {
    name: "Tushar Jajoria",
    role: "Video Editor",
    tagline: "Video Editor focused on turning ideas into engaging visual experiences.",
    // Your photo (shown 1:1 in the About section) — swap this URL anytime
    photo: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/4umvy19f_WhatsApp%20Image%202026-09-12%20at%206.59.13%20PM.jpeg",
    // Contact email (used by the CTA button + footer mail icon)
    email: "tusharjajoria@gmail.com",
    // Social profile links
    socials: [
        { name: "Instagram", url: "https://www.instagram.com/tusharjajoria?stkn=MTRqNHdwMW81dGw1" },
        { name: "LinkedIn", url: "#" },
        { name: "YouTube", url: "#" },
        { name: "Email", url: "mailto:tusharjajoria@gmail.com" },
    ],
};

export const aboutParagraphs = [
    "I'm Tushar, a video editor passionate about transforming ideas into engaging visual stories. I work with Premiere Pro, After Effects and other creative tools to create videos that are visually strong, dynamic and memorable.",
    "From long-form YouTube videos to short-form social content, I enjoy experimenting with editing, motion graphics, pacing, transitions and visual storytelling.",
];

// Software / skills strip (shown in the marquee below the hero)
export const skills = [
    { name: "Adobe Premiere Pro", mark: "Pr", bg: "#00005b", fg: "#9999ff" },
    { name: "Adobe After Effects", mark: "Ae", bg: "#1f0740", fg: "#9999ff" },
    { name: "Adobe Photoshop", mark: "Ps", bg: "#001e36", fg: "#31a8ff" },
    { name: "Motion Graphics", icon: "sparkles" },
    { name: "Color Correction", icon: "palette" },
    { name: "Figma", mark: "Fg", bg: "#1e1e1e", fg: "#a259ff" },
    { name: "Canva", logo: "canva" },
    { name: "Frame.io", logo: "frameio" },
];

// ---------------------------------------------
// LONG FORM — url: paste a YouTube link to make
// the card clickable. Leave "" to disable.
// thumbnail: swap with your own 16:9 image URL/path.
// ---------------------------------------------
export const longFormProjects = [
    {
        id: "lf-1",
        title: "YouTube Documentary",
        category: "Documentary",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/6c0abad8dcc686d09a7e451aea35af7075227ac87a687bb94d7ba33031b5ec15.jpeg",
        url: "https://youtu.be/Q-ftMw5IoWI",
    },
    {
        id: "lf-2",
        title: "Explainer Video",
        category: "Explainer",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/367a4a6f7eba076e98691fba9725a4c847ec3bbe71ca209ac824d8285eff42f2.jpeg",
        url: "https://youtu.be/0tSUsbCcJSY",
    },
    {
        id: "lf-3",
        title: "Educational YouTube Video",
        category: "YouTube",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/a9ef0048f2bdb48fc9d06f6aac95f54a00b04bf6bcbf245983d9d2c06a9c5252.jpeg",
        url: "https://youtu.be/OwKIRPC0vQA",
    },
    {
        id: "lf-4",
        title: "Storytelling Video",
        category: "Narrative",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/0bd2ab7590c4380c74db0f299c9bb0ab2a4d6fc0935d6d261e391ba68974c7c3.jpeg",
        url: "",
    },
    {
        id: "lf-5",
        title: "Creator's Video",
        category: "Creator Content",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/e630e54d4c4cccba3c6bffa7b9c738c4da40e55a9f6f40bea76b8d354e9795b6.jpeg",
        url: "",
    },
];

// ---------------------------------------------
// SHORT FORM (9:16) — url: paste the Reel/Short link.
// ---------------------------------------------
export const shortFormProjects = [
    {
        id: "sf-1",
        title: "Instagram Reel",
        category: "Reels",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/8ffe74146c7c0c55cc3d3b61a15aa3229eff330141f39bbcaa94005e8b2aaaed.jpeg",
        url: "https://youtube.com/shorts/kmP0qtEJux8",
    },
    {
        id: "sf-2",
        title: "YouTube Short",
        category: "Shorts",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/43e26f1a6ae26db10c0e45c487aa18a0077b7716d4433693c2ebbd147940051e.jpeg",
        url: "https://youtube.com/shorts/0yM4gtuga9g",
    },
    {
        id: "sf-3",
        title: "Educational Reel",
        category: "Reels",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/b79e5cf5e2d0a7d6b0db2f71dff2e0a17e068c1cf82ea37fa697d6088a14132f.jpeg",
        url: "https://youtube.com/shorts/KZp9VZG_woA",
    },
    {
        id: "sf-4",
        title: "Talking Head Reel",
        category: "Reels",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/124ccfd8f18446edd4dfbd24ba1e7204b8739cc18b35a40ce062e9f7da214872.jpeg",
        url: "",
    },
    {
        id: "sf-5",
        title: "Motion Graphics Short",
        category: "Motion Graphics",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/bfab5624d96027a82aebfdf6dfc257bf8211adda8722e1bfc896c114a6b623a3.jpeg",
        url: "",
    },
    {
        id: "sf-6",
        title: "Social Media Edit",
        category: "Social Media",
        thumbnail: "https://static.prod-images.emergentagent.com/jobs/6dd98ab1-aac1-4bda-8275-ce66f96d4e31/images/2c102acee8a7d4c4f67dc13710042c197937f5be2080d138933fe6919be24481.jpeg",
        url: "",
    },
];

// ---------------------------------------------
// MOTION GRAPHICS — one object per project:
// {
//   title: "Kinetic Typography",
//   category: "Motion Graphics",
//   thumbnail: "/images/motion-01.jpg",
//   video: "/videos/motion-01.mp4",   // local file OR YouTube/Vimeo URL
//   url: "",                          // optional external "View Project" link
//   description: "…"
// }
// Local files go in /frontend/public (e.g. /videos/motion-01.mp4).
// YouTube (watch/youtu.be) and Vimeo links play in an embedded player.
// Leave video: "" to show a "coming soon" placeholder in the modal.
// ---------------------------------------------
export const motionProjects = [
    {
        id: "mg-1",
        title: "Comp 1",
        category: "Motion Graphics",
        thumbnail: "/videos/mg-1.jpg",
        video: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/g18801wg_Comp%201_3.mp4",
        url: "",
        description: "Motion graphics loop — plays automatically on the card.",
    },
    {
        id: "mg-2",
        title: "Content Final",
        category: "Motion Graphics",
        thumbnail: "/videos/mg-2.jpg",
        video: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/2bybqyp0_Content%20final.mp4",
        url: "",
        description: "Motion graphics loop — plays automatically on the card.",
    },
    {
        id: "mg-3",
        title: "Pandemic Relief",
        category: "Motion Graphics",
        thumbnail: "/videos/mg-3.jpg",
        video: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/gf5wmaz1_Pandemic%20Relief.mp4",
        url: "",
        description: "Explainer-style motion graphics piece.",
    },
    {
        id: "mg-4",
        title: "Stripe",
        category: "Motion Graphics",
        thumbnail: "/videos/mg-4.jpg",
        video: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/w4sexsol_Stripe.mp4",
        url: "",
        description: "UI-inspired motion graphics animation.",
    },
    {
        id: "mg-5",
        title: "UFO",
        category: "Motion Graphics",
        thumbnail: "/videos/mg-5.jpg",
        video: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/h3qg9pwl_Ufo.mp4",
        url: "",
        description: "Playful motion graphics animation.",
    },
    {
        id: "mg-6",
        title: "Energy Drinks",
        category: "Motion Graphics",
        thumbnail: "/videos/mg-6.jpg",
        video: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/226hxf11_Energy%20Drinks%20Final_1.mp4",
        url: "",
        description: "Brand-driven motion graphics edit.",
    },
];

// ---------------------------------------------
// MY FRAMES — static design work (posters, thumbnails,
// typography, visual compositions). No video here.
// ---------------------------------------------
export const framesProjects = [
    {
        id: "fr-1",
        title: "Energy Drinks",
        category: "Brand Composition",
        thumbnail: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/m5tkq4mo_Energy%20Drinks%20Final.00_00_01_02.Still001.jpg",
    },
    {
        id: "fr-2",
        title: "Warren Buffett Quote",
        category: "Quote Frame",
        thumbnail: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/67xhkut6_Q-3.png",
    },
    {
        id: "fr-3",
        title: "PharmEasy Valuation Drop",
        category: "Explainer Frame",
        thumbnail: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/qbxma286_Q-4.png",
    },
    {
        id: "fr-4",
        title: "JEE Fail Story",
        category: "Storytelling Frame",
        thumbnail: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/s6qbb4rr_Q-6.png",
    },
    {
        id: "fr-5",
        title: "Economists & Policymakers",
        category: "Editorial Frame",
        thumbnail: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/rvi3rv2u_Screenshot%202026-09-12%20181359.png",
    },
    {
        id: "fr-6",
        title: "Settling Abroad",
        category: "Creative Frame",
        thumbnail: "https://customer-assets-v7afamib.emergentagent.net/job_motion-craft-387/artifacts/d9jfbyk4_Screenshot%202026-09-12%20181444.png",
    },
];
